import React, { useState } from 'react';
import { Info } from 'lucide-react';
import { toast } from 'react-toastify';

const FeedbackModal = ({ isOpen, onClose }) => {
    const fullUrl = window.location.href;
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        remark: '',
        enquiry_source: 'Feeback Page',
        source: fullUrl,
        main_id: "HBTR0001"
    });
    const url = process.env.REACT_APP_LINK
    const [errors, setErrors] = useState({});
    const [submittedOnce, setSubmittedOnce] = useState(false);
    const [loading, setLoading] = useState(false);

    const login = JSON.parse(localStorage.getItem("2xgxgshdugyywerw12"));

    const validateField = (name, value) => {
        if (name === 'name') return value.trim() === '';
        if (name === 'email') return !/\S+@\S+\.\S+/.test(value);
        if (name === 'remark') return value.trim() === '';
        return false;
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));

        if (submittedOnce) {
            setErrors(prev => ({ ...prev, [name]: validateField(name, value) }));
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setSubmittedOnce(true);

        const nameErr = validateField('name', formData.name);
        const emailErr = validateField('email', formData.email);
        const remarkErr = validateField('description', formData.remark);
        const newErrors = { name: nameErr, email: emailErr, remark: remarkErr };

        setErrors(newErrors);

        if (nameErr || emailErr || remarkErr) {
            toast.error('Please fix the errors.');
            return;
        }

        setLoading(true);
        try {
            const response = await fetch(`${url}/contact`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify({
                    name: formData.name,
                    email: formData.email,
                    remark: formData.remark,
                    user_id: "HBTR0001",
                    message: "Feedback"
                })
            });

            if (response.status === 200 || response.status === 201) {
                alert("Thank you for sharing your valuable feedback");
                setFormData({ name: '', email: '', remark: '' });
                setErrors({});
                setSubmittedOnce(false);
                onClose(); // Close the modal
            } else {
                toast.error("Failed to submit feedback.");
            }

        } catch (error) {
            console.error("Error sending feedback:", error);
            toast.error("An error occurred. Please try again.");
        } finally {
            setLoading(false);
        }
    };

    if (!isOpen) return null;

    return (
        <div className="feed-modal-overlay">
            <div className="feed-modal">
                <button onClick={onClose} className="feed-close-btn">×</button>
                <h2 className='feed-modal-heading'>Send Feedback</h2>
                <form onSubmit={handleSubmit}>
                    <div className="form-group-fb" style={{ position: 'relative' }}>
                        <label htmlFor="name">Name</label>
                        <input
                            name="name"
                            id="name"
                            type="text"
                            placeholder="Your Name"
                            value={formData.name}
                            onChange={handleChange}
                            className={errors.name ? 'input-error' : ''}
                            style={{ paddingRight: '35px' }}
                        />
                        {errors.name && <Info className="input-icon" style={{
                            position: 'absolute',
                            right: '10px',
                            top: '40px',
                            pointerEvents: 'none',
                            color: 'red',
                        }} />}
                    </div>

                    <div className="form-group-fb" style={{ position: 'relative' }}>
                        <label htmlFor="email">Email</label>
                        <input
                            name="email"
                            id="email"
                            type="email"
                            placeholder="Your Email"
                            value={formData.email}
                            onChange={handleChange}
                            className={errors.email ? 'input-error' : ''}
                            style={{ paddingRight: '35px' }}
                        />
                        {errors.email && <Info className="input-icon" style={{
                            position: 'absolute',
                            right: '10px',
                            top: '40px',
                            pointerEvents: 'none',
                            color: 'red',
                        }} />}
                    </div>

                    <div className="form-group-fb" style={{ position: 'relative' }}>
                        <label htmlFor="remark">Message</label>
                        <textarea
                            name="remark"
                            id="remark"
                            rows={5}
                            placeholder="Your Feedback"
                            value={formData.remark}
                            onChange={handleChange}
                            className={errors.remark ? 'input-error' : ''}
                            style={{ paddingRight: '35px' }}
                        />
                        {errors.remark && <Info className="input-icon" style={{
                            position: 'absolute',
                            right: '10px',
                            top: '40px',
                            pointerEvents: 'none',
                            color: 'red',
                        }} />}
                    </div>

                    <button type="submit" className="submit-btn-fb" disabled={loading}>
                        {loading ? 'Sending...' : 'Send Feedback'}
                    </button>
                </form>
            </div>
        </div>
    );
};

export default FeedbackModal;
